import type { FileResponse } from "@/lib/api";
import { DocumentDownload } from "@/components/surety-account/DocumentDownload";

// BRK-S406 — a Bond history row's executed bond form. The PDF is an
// `account_document`, so it downloads through the ACCOUNT's document route
// (BRK-S146: one download door for every broker-visible document); the caller
// hands in that read. The button and its inline failure are the shared
// `DocumentDownload`.

export function BondFormDownload({
  number,
  download,
}: {
  /** The submission's SB number: the button's name and the fallback file
   *  name for a response that carries none. */
  number: string;
  download: () => Promise<FileResponse>;
}) {
  return (
    <DocumentDownload
      label={`Download the bond form for ${number}`}
      fallbackName={`${number}-bond-form.pdf`}
      download={download}
    />
  );
}
